"use client";

import { c as _c } from "react-compiler-runtime";
import { AnimatePresence, motion } from "motion/react";
import { useEffect, useState } from "react";
import { Text } from "@/components/primitives";
const DEFAULT_HOLD_MS = 1500;
type CaptureIntroOverlayProps = {
  message: string;
  durationMs?: number;
  onComplete?: () => void;
};
export function CaptureIntroOverlay(t0) {
  const $ = _c(9);
  const {
    message,
    durationMs: t1,
    onComplete
  } = t0;
  const durationMs = t1 === undefined ? DEFAULT_HOLD_MS : t1;
  const [visible, setVisible] = useState(true);
  let t2;
  let t3;
  if ($[0] !== durationMs || $[1] !== onComplete) {
    t2 = () => {
      const timer = setTimeout(() => {
        setVisible(false);
        onComplete?.();
      }, durationMs);
      return () => clearTimeout(timer);
    };
    t3 = [durationMs, onComplete];
    $[0] = durationMs;
    $[1] = onComplete;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== message || $[5] !== visible) {
    t4 = visible && <motion.div animate={{
      opacity: 1
    }} className="absolute inset-0 z-40 flex items-center justify-center bg-black/90" exit={{
      opacity: 0
    }} initial={{
      opacity: 1
    }} transition={{
      duration: 0.5
    }}><motion.div animate={{
        opacity: 1,
        scale: 1
      }} className="px-6 text-center" initial={{
        opacity: 0,
        scale: 0.95
      }} transition={{
        duration: 0.25
      }}><Text component="p" text={message} tone="white" variant="heading-lg" weight="medium" /></motion.div></motion.div>;
    $[4] = message;
    $[5] = visible;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <AnimatePresence>{t4}</AnimatePresence>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}